module.exports = __webpack_public_path__ + "img/copy-light.68e70715.svg";